export interface Article {
  id: number;
  slug: string;
  title: string;
  excerpt: string;
  content: string;
  date: string;
  category: string;
  author: string;
  imageSeq: string;
  imageQuery: string;
  tags: string[];
}

export const allArticles: Article[] = [
  {
    id: 1,
    slug: 'xiazai-jiaocheng-2026',
    title: '91在线视频APP下载安装完整教程（2026最新版）',
    excerpt: '本文详细介绍91在线视频APP在iOS和Android设备上的下载安装步骤，以及常见问题排查方法，帮助用户快速完成APP安装。',
    content: `<p>随着移动互联网的快速发展，越来越多的用户选择通过手机观看在线视频。91在线视频APP凭借其流畅的播放体验和丰富的内容库，成为了众多用户的首选。本文将为您详细介绍如何正确下载和安装91在线视频APP。</p>
<h2>一、Android设备下载安装教程</h2>
<p>1. 打开手机浏览器，访问91在线视频官方网站。</p>
<p>2. 在首页找到"APP下载"区域，点击"Android版下载"按钮。</p>
<p>3. 下载完成后，点击安装包进行安装。如果系统提示"未知来源"，请在设置中开启"允许安装未知应用"权限。</p>
<p>4. 安装完成后，打开APP即可开始使用。首次使用建议注册账号，享受更多专属功能。</p>
<h2>二、iOS设备下载安装教程</h2>
<p>1. 打开App Store，搜索"91在线视频"。</p>
<p>2. 找到官方应用，点击"获取"按钮进行下载。</p>
<p>3. 下载完成后，APP将自动安装到您的设备上。</p>
<p>4. 打开APP，使用Apple ID登录或注册新账号即可。</p>
<h2>三、常见问题解答</h2>
<p><strong>Q: 为什么Android下载后无法安装？</strong></p>
<p>A: 请检查手机是否开启了"允许安装未知应用"的权限，该选项通常在"设置-安全"中可以找到。</p>
<p><strong>Q: iOS搜索不到APP怎么办？</strong></p>
<p>A: 请确保您使用的是中国大陆区Apple ID，或将App Store区域切换至中国大陆。</p>
<h2>四、版本更新说明</h2>
<p>91在线视频APP持续进行功能优化和体验升级。建议用户开启自动更新功能，以便第一时间享受最新功能和最佳体验。</p>`,
    date: '2026-07-06',
    category: '使用教程',
    author: '91在线视频官方',
    imageSeq: 'article-detail-01',
    imageQuery: 'Clean modern smartphone showing video app interface, minimalist tech setup, warm ambient lighting, professional product photography, soft shadows, neutral background',
    tags: ['APP下载', '安装教程', '使用指南'],
  },
  {
    id: 2,
    slug: 'vip-gongneng-jieshao',
    title: '91在线视频VIP会员权益全面解析',
    excerpt: '详细了解VIP会员专属权益：无广告观看、超清画质、离线缓存、专属客服等内容，助你做出最佳选择。',
    content: `<p>91在线视频VIP会员是为追求极致观影体验的用户量身打造的增值服务。本文全面解析VIP会员的各项专属权益，帮助您了解会员价值的方方面面。</p>
<h2>一、VIP会员核心权益</h2>
<p><strong>1. 无广告纯净观影</strong></p>
<p>VIP会员可享受全站无广告观影体验，告别片头广告和插播广告的打扰，沉浸式享受每一部影片。</p>
<p><strong>2. 超清4K画质</strong></p>
<p>VIP会员独享4K超高清画质选项，在支持设备上体验影院级视觉享受。画面细节纤毫毕现，色彩还原真实自然。</p>
<p><strong>3. 无限离线缓存</strong></p>
<p>支持将喜欢的影片缓存到本地，无网络环境下也能随时观看。通勤、旅行、出差时再也不用担心流量问题。</p>
<p><strong>4. 多设备同时登录</strong></p>
<p>一个VIP账号支持3台设备同时在线观看，家人朋友可共享会员权益。</p>
<p><strong>5. 专属客服通道</strong></p>
<p>VIP会员享有专属客服快速响应通道，问题优先处理，享受更贴心的服务体验。</p>
<h2>二、VIP会员价格方案</h2>
<p>月度会员：¥25/月</p>
<p>季度会员：¥68/季（享9折优惠）</p>
<p>年度会员：¥238/年（享8折优惠）</p>
<h2>三、如何开通VIP</h2>
<p>打开91在线视频APP，进入"我的"页面，点击"开通VIP"按钮，选择适合的方案即可完成开通。</p>`,
    date: '2026-07-04',
    category: '功能更新',
    author: '91在线视频官方',
    imageSeq: 'article-detail-02',
    imageQuery: 'Premium membership concept with elegant gold accents, luxury lifestyle aesthetic, dark background with warm highlights, sophisticated visual, clean composition',
    tags: ['VIP会员', '会员权益', '功能介绍'],
  },
  {
    id: 3,
    slug: 'xinpian-shangxian-7yue',
    title: '2026年7月最新上线影片清单',
    excerpt: '本月多部热门大片和电视剧陆续上线，包括多部豆瓣高分作品。快来看看有没有你期待的内容吧！',
    content: `<p>每月初，91在线视频都会更新一批精彩影片。2026年7月的新片单格外丰富，涵盖电影、电视剧、综艺等多个品类，让我们一起来看看本月的精彩内容吧！</p>
<h2>一、电影专区</h2>
<p><strong>《星际迷航：新生》</strong> - 科幻巨制续作，豆瓣开分8.5</p>
<p><strong>《长安三万里2》</strong> - 国漫巅峰续作，视觉盛宴再升级</p>
<p><strong>《无名英雄》</strong> - 战争题材力作，张艺谋执导</p>
<p><strong>《夏日奇迹》</strong> - 治愈系青春电影，适合全家观看</p>
<h2>二、电视剧专区</h2>
<p><strong>《繁华之下》第三季</strong> - 都市情感大戏，首日播放量破亿</p>
<p><strong>《风起云涌》</strong> - 古装权谋新剧，制作精良</p>
<p><strong>《异能事务所》第二季</strong> - 奇幻悬疑剧回归，口碑爆棚</p>
<h2>三、综艺专区</h2>
<p><strong>《欢乐大本营》最新季</strong> - 经典综艺全新回归</p>
<p><strong>《声入人心》第四季</strong> - 音乐竞演类综艺</p>
<h2>四、动漫专区</h2>
<p><strong>《灵笼》第二季</strong> - 国产科幻动画神作回归</p>
<p><strong>《鬼灭之刃》最新剧场版</strong> - 日漫人气作品</p>
<p>以上影片将在7月陆续上线，敬请期待！具体上线时间以站内公告为准。</p>`,
    date: '2026-07-03',
    category: '内容推荐',
    author: '91在线视频编辑组',
    imageSeq: 'article-detail-03',
    imageQuery: 'Film reel and cinema concept, artistic movie themed still life, warm vintage tones, creative composition, soft dramatic lighting, cinematography aesthetic',
    tags: ['最新影片', '电影推荐', '内容更新'],
  },
  {
    id: 4,
    slug: 'anquan-fangwen-zhinan',
    title: '91在线视频安全访问指南',
    excerpt: '为了保障您的账号和隐私安全，请务必通过官方渠道访问91在线视频。本文详细说明安全访问的注意事项和常见问题。',
    content: `<p>网络安全是每位互联网用户都应重视的问题。91在线视频始终将用户安全和隐私保护放在首位。本文将为您介绍如何安全、放心地使用91在线视频。</p>
<h2>一、通过官方渠道访问</h2>
<p>请务必通过以下官方渠道访问91在线视频：</p>
<p>1. 官方网站：www.91zaixianshipin.com</p>
<p>2. 官方APP：通过官网或正规应用商店下载</p>
<p>请勿通过不明来源的第三方链接访问，以免遭受钓鱼网站或恶意软件的侵害。</p>
<h2>二、账户安全建议</h2>
<p>1. 设置强密码：建议使用字母、数字和特殊字符的组合，长度不少于8位。</p>
<p>2. 定期更换密码：建议每3个月更换一次登录密码。</p>
<p>3. 不要共享账号：请勿将账号密码告知他人或在公共设备上保存登录状态。</p>
<p>4. 开启双重验证：在APP中开启手机验证等额外安全措施。</p>
<h2>三、防范钓鱼网站</h2>
<p>请认准91在线视频官方网站域名。如发现可疑网站冒充91在线视频，请及时向官方举报。</p>
<h2>四、联系我们</h2>
<p>如遇到安全问题或有任何疑问，请联系官方客服邮箱：support@91zaixianshipin.com</p>`,
    date: '2026-07-01',
    category: '安全公告',
    author: '91在线视频安全团队',
    imageSeq: 'article-detail-04',
    imageQuery: 'Cyber security concept with shield and lock symbols, clean modern design, professional tech aesthetic, warm tones, minimalist style, soft lighting',
    tags: ['安全指南', '账号安全', '防诈骗'],
  },
  {
    id: 5,
    slug: 'huazhi-shezhi-jiaocheng',
    title: '视频画质与播放设置优化教程',
    excerpt: '根据网络环境和设备性能，合理调整视频画质和播放参数，获得最佳观影体验。详细设置步骤一网打尽。',
    content: `<p>良好的观影体验不仅取决于内容本身，还与播放设置密切相关。本文将教您如何根据自身设备和网络条件，优化91在线视频的播放参数。</p>
<h2>一、画质选择指南</h2>
<p>91在线视频支持多种画质选项：流畅（360P）、标清（480P）、高清（720P）、超清（1080P）、4K。选择建议：</p>
<p>- WiFi环境下推荐1080P或4K画质</p>
<p>- 移动数据环境下推荐720P或480P画质</p>
<p>- 弱网环境下可选择360P流畅模式</p>
<h2>二、倍速播放功能</h2>
<p>支持0.5x至2.0x多档倍速播放，适用于不同类型的内容观看需求。</p>
<h2>三、字幕设置</h2>
<p>支持中文字幕、双语字幕及无字幕模式，可根据个人喜好自由切换。</p>`,
    date: '2026-06-28',
    category: '使用教程',
    author: '91在线视频官方',
    imageSeq: 'article-detail-05',
    imageQuery: 'Modern TV screen showing video settings interface, clean tech aesthetic, warm ambient lighting, minimalist living room setup, professional product photography',
    tags: ['画质设置', '播放优化', '使用教程'],
  },
  {
    id: 6,
    slug: 'shequ-gongyue-gengxin',
    title: '社区公约更新：共建文明观影环境',
    excerpt: '91在线视频社区公约2026版正式发布，新增弹幕礼仪规范和评论互动准则，共同维护良好的社区氛围。',
    content: `<p>为营造健康、积极的社区氛围，91在线视频对社区公约进行了全面升级。新公约已于2026年7月1日正式生效。</p>
<h2>一、弹幕互动规范</h2>
<p>1. 禁止发布人身攻击、辱骂等不友善言论。</p>
<p>2. 禁止剧透未观看集数的关键情节。</p>
<p>3. 禁止发布广告、引流等商业信息。</p>
<h2>二、评论互动准则</h2>
<p>鼓励有质量的影评和讨论，尊重不同观点，理性交流。</p>
<h2>三、违规处理</h2>
<p>违反社区公约的用户将根据情节轻重，受到警告、禁言、封号等处理。</p>`,
    date: '2026-06-25',
    category: '站内公告',
    author: '91在线视频运营组',
    imageSeq: 'article-detail-06',
    imageQuery: 'Community guidelines concept illustration, warm harmonious colors, abstract people figures, clean modern design, friendly atmosphere, soft gradients',
    tags: ['社区公约', '弹幕规范', '站内公告'],
  },
];

export const categoryDetails: Record<string, { name: string; description: string; icon: string; videos: { id: number; title: string; category: string; description: string; imageSeq: string; imageQuery: string }[] }> = {
  remen: {
    name: '热门精选',
    description: '全网最热门的视频内容汇聚于此，每日实时更新热门榜单。涵盖电影、剧集、综艺等多个品类，紧跟潮流不落伍。',
    icon: 'ri-fire-line',
    videos: [
      { id: 1, title: '年度最佳悬疑大片《暗夜追踪》全网首播', category: '电影', description: '豆瓣评分8.9，年度必看悬疑力作，反转烧脑不容错过。', imageSeq: 'cat-hot-01', imageQuery: 'Cinematic movie poster with dark noir aesthetic, mysterious silhouette against city nightscape, dramatic lighting with warm amber tones, film grain texture, professional movie poster style' },
      { id: 2, title: '热门都市剧《繁华之下》第三季火热更新', category: '剧集', description: '全网播放量突破50亿，都市情感大戏持续热播中。', imageSeq: 'cat-hot-02', imageQuery: 'Modern urban drama series poster with city skyline at sunset, warm golden light, elegant aesthetic, emotional atmosphere, professional drama series key visual' },
      { id: 3, title: '现象级综艺《欢乐大本营》最新季回归', category: '综艺', description: '原班人马全新出发，笑点密集，每周五晚准时更新。', imageSeq: 'cat-hot-03', imageQuery: 'Colorful variety show poster with vibrant stage lights, cheerful atmosphere, entertainment show aesthetic, bright colorful spotlights, festive mood' },
      { id: 4, title: '《星际迷航：新生》震撼上映', category: '电影', description: '科幻巨制续作，视觉特效全面升级，IMAX推荐观看。', imageSeq: 'cat-hot-04', imageQuery: 'Epic sci-fi movie poster with spaceship in deep space, dramatic nebula colors, cinematic lighting, professional film poster, grand scale composition' },
      { id: 5, title: '治愈系纪录片《人间至味》暖心上线', category: '纪录片', description: '走进中国各地的美食故事，感受人间烟火的温暖与感动。', imageSeq: 'cat-hot-05', imageQuery: 'Warm food documentary poster with traditional Chinese cuisine, soft natural lighting, authentic kitchen atmosphere, cultural aesthetic, appetizing presentation' },
      { id: 6, title: '国漫《长安三万里2》续写辉煌', category: '动漫', description: '前作票房破18亿，续作画质再升级，展现盛唐气象。', imageSeq: 'cat-hot-06', imageQuery: 'Chinese animation movie poster with Tang Dynasty aesthetic, classical Chinese architecture, poetic atmosphere, traditional ink painting style with modern animation quality' },
    ],
  },
  zuixin: {
    name: '最新上线',
    description: '最新上线的视频内容实时更新，不错过每一部新作。第一时间体验最新电影、剧集和综艺节目。',
    icon: 'ri-timer-line',
    videos: [
      { id: 1, title: '《风起云涌》第1-8集一次性放出', category: '剧集', description: '古装权谋大剧重磅开播，豪华演员阵容，制作精良。', imageSeq: 'cat-new-01', imageQuery: 'Historical Chinese drama poster with ancient palace architecture, dramatic atmosphere, rich costume details, cinematic lighting, epic scale' },
      { id: 2, title: '《无名英雄》今日首映', category: '电影', description: '张艺谋执导战争题材力作，致敬那个年代的英雄。', imageSeq: 'cat-new-02', imageQuery: 'War drama film poster with heroic soldier silhouette at golden hour, dramatic sky, epic and emotional atmosphere, cinematic style' },
      { id: 3, title: '《异能事务所》第二季第1集', category: '剧集', description: '奇幻悬疑剧回归，首集悬念拉满，口碑爆棚。', imageSeq: 'cat-new-03', imageQuery: 'Mystery thriller series poster with supernatural elements, dark moody atmosphere, neon accents, modern urban fantasy aesthetic' },
      { id: 4, title: '纪录片《深海探秘》震撼上线', category: '纪录片', description: '4K超清画质，带你走进神秘的深海世界。', imageSeq: 'cat-new-04', imageQuery: 'Ocean documentary poster with deep sea creatures, bioluminescent effects, dark blue underwater atmosphere, scientific exploration aesthetic' },
      { id: 5, title: '《笑傲江湖2026》喜剧专场', category: '综艺', description: '全新喜剧竞技节目，各路笑星同台PK。', imageSeq: 'cat-new-05', imageQuery: 'Comedy show poster with bright stage lighting, cheerful atmosphere, entertainment show aesthetic, colorful spotlights, festive mood' },
      { id: 6, title: '《灵笼》第二季震撼回归', category: '动漫', description: '国产科幻动画天花板，世界观全面展开。', imageSeq: 'cat-new-06', imageQuery: 'Sci-fi Chinese animation poster with futuristic mecha design, post-apocalyptic atmosphere, dramatic lighting, high quality animation style' },
    ],
  },
  dianying: {
    name: '电影大片',
    description: '海量高清电影片库，涵盖动作、喜剧、爱情、科幻、悬疑等全类型影片。从经典老片到最新大片，应有尽有。',
    icon: 'ri-movie-2-line',
    videos: [
      { id: 1, title: '《暗夜追踪》', category: '悬疑', description: '豆瓣8.9，年度最佳悬疑力作，反转烧脑。', imageSeq: 'cat-movie-01', imageQuery: 'Noir thriller film poster with mysterious detective silhouette, rain-slicked city streets at night, dramatic shadows, cinematic lighting' },
      { id: 2, title: '《星际迷航：新生》', category: '科幻', description: 'IMAX视觉盛宴，科幻迷不可错过。', imageSeq: 'cat-movie-02', imageQuery: 'Epic space opera film poster with massive starship, colorful nebula, dramatic sci-fi lighting, grand scale cinematic composition' },
      { id: 3, title: '《无名英雄》', category: '战争', description: '张艺谋最新力作，感人至深。', imageSeq: 'cat-movie-03', imageQuery: 'War drama film poster with heroic soldier at golden sunset, dramatic skies, emotional atmosphere, award-winning cinematic style' },
      { id: 4, title: '《夏日奇迹》', category: '青春', description: '治愈系青春电影，适合全家观看。', imageSeq: 'cat-movie-04', imageQuery: 'Heartwarming youth film poster with summer countryside scenery, soft golden sunlight, nostalgic atmosphere, gentle color palette' },
      { id: 5, title: '《深海危机》', category: '灾难', description: '特效大片，深海钻井平台灾难。', imageSeq: 'cat-movie-05', imageQuery: 'Disaster film poster with massive ocean oil rig explosion, dramatic orange fire against dark sea, high intensity action atmosphere' },
      { id: 6, title: '《爱情公寓大电影》', category: '喜剧', description: '原班人马回归，爆笑升级。', imageSeq: 'cat-movie-06', imageQuery: 'Romantic comedy film poster with cheerful group of friends, bright colorful apartment setting, happy atmosphere, modern lifestyle aesthetic' },
    ],
  },
  dianshiju: {
    name: '电视剧集',
    description: '热门电视剧全集收录，国产剧、韩剧、美剧、日剧等一应俱全。每日更新，追剧党必备。',
    icon: 'ri-tv-2-line',
    videos: [
      { id: 1, title: '《繁华之下》第三季', category: '都市', description: '全网50亿播放量，情感大戏持续升温。', imageSeq: 'cat-drama-01', imageQuery: 'Modern urban drama series poster with city skyline at twilight, sophisticated atmosphere, emotional visual storytelling, premium TV series aesthetic' },
      { id: 2, title: '《风起云涌》', category: '古装', description: '权谋大剧，制作精良值得一看。', imageSeq: 'cat-drama-02', imageQuery: 'Historical Chinese palace drama poster with intricate costume details, ancient architecture, dramatic atmosphere, epic series visual' },
      { id: 3, title: '《异能事务所》第二季', category: '奇幻', description: '悬疑奇幻，口碑续作回归。', imageSeq: 'cat-drama-03', imageQuery: 'Supernatural mystery drama poster with urban fantasy elements, neon city lights, mysterious atmosphere, modern thriller visual style' },
      { id: 4, title: '《时光代理人》', category: '悬疑', description: '时间穿越题材，烧脑推理。', imageSeq: 'cat-drama-04', imageQuery: 'Time travel mystery series poster with clock elements, surreal atmosphere, modern noir visual style, intriguing composition' },
      { id: 5, title: '《爱情的理解》', category: '爱情', description: '韩式浪漫爱情剧，甜度满分。', imageSeq: 'cat-drama-05', imageQuery: 'Romantic Korean drama style poster with couple silhouette at golden hour, soft bokeh lighting, emotional and warm atmosphere' },
      { id: 6, title: '《职场风云》', category: '职场', description: '真实还原职场生态，引人共鸣。', imageSeq: 'cat-drama-06', imageQuery: 'Modern office drama series poster with professional workplace setting, modern corporate aesthetic, clean composition, sophisticated atmosphere' },
    ],
  },
  zongyi: {
    name: '综艺娱乐',
    description: '热门综艺节目实时更新，音乐竞演、真人秀、脱口秀等精彩内容不间断放送，为你的休闲时光增添乐趣。',
    icon: 'ri-live-line',
    videos: [
      { id: 1, title: '《欢乐大本营》最新季', category: '娱乐', description: '原班人马回归，每周五晚更新。', imageSeq: 'cat-variety-01', imageQuery: 'Popular variety show stage with colorful lighting, cheerful entertainment atmosphere, bright spotlights, festive TV show aesthetic' },
      { id: 2, title: '《声入人心》第四季', category: '音乐', description: '顶级音乐竞演，声乐盛宴。', imageSeq: 'cat-variety-02', imageQuery: 'Music competition show stage with dramatic spotlight, elegant concert atmosphere, professional performance aesthetic, sophisticated lighting' },
      { id: 3, title: '《极限挑战2026》', category: '真人秀', description: '户外挑战全新升级，笑点不断。', imageSeq: 'cat-variety-03', imageQuery: 'Outdoor adventure reality show poster with natural landscape, exciting atmosphere, energetic group activity, bright daylight photography' },
      { id: 4, title: '《脱口秀大会》第六季', category: '脱口秀', description: '各路笑匠同台竞技，金句频出。', imageSeq: 'cat-variety-04', imageQuery: 'Stand-up comedy show poster with microphone on stage, spotlight effect, modern entertainment venue, professional comedy club atmosphere' },
      { id: 5, title: '《创造营2026》', category: '选秀', description: '偶像养成节目，见证新星诞生。', imageSeq: 'cat-variety-05', imageQuery: 'Idol survival show stage with dazzling lights, modern performance venue, energetic atmosphere, K-pop inspired visual aesthetic' },
      { id: 6, title: '《舞蹈风暴》第三季', category: '舞蹈', description: '国内顶级舞者汇聚一堂。', imageSeq: 'cat-variety-06', imageQuery: 'Dance competition show poster with dynamic dancer silhouette, dramatic stage lighting, artistic movement capture, elegant performance aesthetic' },
    ],
  },
  dongman: {
    name: '动漫动画',
    description: '热血、搞笑、治愈、悬疑各类动漫一网打尽，日漫国漫全收录。二次元爱好者的天堂，持续更新中。',
    icon: 'ri-ancient-gate-line',
    videos: [
      { id: 1, title: '《长安三万里2》', category: '国漫', description: '盛唐气象，视觉盛宴再升级。', imageSeq: 'cat-anime-01', imageQuery: 'Chinese animation movie poster with Tang Dynasty aesthetic, classical poetry atmosphere, traditional ink painting style, epic historical visual' },
      { id: 2, title: '《灵笼》第二季', category: '国漫', description: '国产科幻动画天花板回归。', imageSeq: 'cat-anime-02', imageQuery: 'Chinese sci-fi animation poster with futuristic mecha, post-apocalyptic world, dramatic lighting, high quality 3D animation style' },
      { id: 3, title: '《鬼灭之刃》剧场版', category: '日漫', description: '人气日漫最新剧场版上线。', imageSeq: 'cat-anime-03', imageQuery: 'Japanese anime movie poster with samurai theme, dramatic action pose, traditional Japanese art style mixed with modern animation, dynamic composition' },
      { id: 4, title: '《一人之下》第五季', category: '国漫', description: '道家文化背景的异能战斗番。', imageSeq: 'cat-anime-04', imageQuery: 'Chinese supernatural anime poster with Taoist elements, martial arts aesthetic, dynamic energy effects, traditional meets modern visual style' },
      { id: 5, title: '《间谍过家家》第二季', category: '日漫', description: '温馨搞笑间谍家庭喜剧。', imageSeq: 'cat-anime-05', imageQuery: 'Japanese comedy anime poster with spy family theme, warm pastel color palette, cute character design, wholesome family atmosphere' },
      { id: 6, title: '《雾山五行》第二章', category: '国漫', description: '水墨画风战斗番，视觉震撼。', imageSeq: 'cat-anime-06', imageQuery: 'Chinese ink painting style animation poster with elemental powers, dramatic battle scene, traditional Chinese art aesthetic, dynamic visual effects' },
    ],
  },
  jilupian: {
    name: '纪录片',
    description: '精选全球优质纪录片，涵盖自然、历史、人文、科技等多个领域。用镜头探索世界的无限精彩。',
    icon: 'ri-camera-lens-line',
    videos: [
      { id: 1, title: '《人间至味》', category: '美食', description: '走进中国各地的美食故事。', imageSeq: 'cat-doc-01', imageQuery: 'Food documentary poster with traditional Chinese cuisine close-up, warm natural lighting, authentic cooking atmosphere, cultural culinary aesthetic' },
      { id: 2, title: '《深海探秘》', category: '自然', description: '4K超清探索神秘深海世界。', imageSeq: 'cat-doc-02', imageQuery: 'Nature documentary poster with deep ocean creatures, bioluminescent effects, dark blue underwater atmosphere, National Geographic style' },
      { id: 3, title: '《故宫600年》', category: '历史', description: '紫禁城的六百年风云变幻。', imageSeq: 'cat-doc-03', imageQuery: 'Historical documentary poster with Forbidden City architecture at golden hour, majestic imperial aesthetic, cultural heritage atmosphere, cinematic quality' },
      { id: 4, title: '《宇宙之旅》', category: '科学', description: '从地球到宇宙边缘的壮丽旅程。', imageSeq: 'cat-doc-04', imageQuery: 'Space documentary poster with galaxy and nebula, stunning cosmic visuals, scientific exploration aesthetic, awe-inspiring scale' },
      { id: 5, title: '《非洲大草原》', category: '自然', description: '野生动物世界的生存传奇。', imageSeq: 'cat-doc-05', imageQuery: 'Wildlife documentary poster with African savanna at sunset, majestic animals in natural habitat, golden hour lighting, BBC Earth style' },
      { id: 6, title: '《人类简史》', category: '人文', description: '从远古到现代的人类文明之旅。', imageSeq: 'cat-doc-06', imageQuery: 'Human history documentary poster with timeline concept, ancient civilization imagery, educational aesthetic, epic historical visual narrative' },
    ],
  },
  duanshipin: {
    name: '短视频',
    description: '精选优质短视频内容，搞笑段子、生活妙招、知识科普、创意剪辑。碎片时间轻松看，每日更新不间断。',
    icon: 'ri-smartphone-line',
    videos: [
      { id: 1, title: '搞笑日常：老板不在的第N天', category: '搞笑', description: '办公室搞笑日常系列。', imageSeq: 'cat-short-01', imageQuery: 'Funny short video thumbnail with office comedy scene, bright cheerful lighting, casual authentic style, social media content aesthetic' },
      { id: 2, title: '1分钟学会做红烧肉', category: '美食', description: '超简单家常菜教程。', imageSeq: 'cat-short-02', imageQuery: 'Cooking tutorial short video thumbnail with braised pork dish, appetizing food photography, warm kitchen lighting, social media food content style' },
      { id: 3, title: '10个生活小妙招', category: '生活', description: '居家必备实用技巧合集。', imageSeq: 'cat-short-03', imageQuery: 'Life hacks short video thumbnail with household items, clean modern aesthetic, bright natural lighting, practical tips visual style' },
      { id: 4, title: '冷知识：为什么天空是蓝色的', category: '科普', description: '30秒了解科学原理。', imageSeq: 'cat-short-04', imageQuery: 'Science education short video thumbnail with blue sky and clouds, clean educational aesthetic, bright outdoor lighting, engaging visual style' },
      { id: 5, title: '旅行Vlog：云南大理', category: '旅行', description: '沉浸式大理旅行体验。', imageSeq: 'cat-short-05', imageQuery: 'Travel vlog thumbnail with Dali ancient town scenery, beautiful natural landscape, warm travel atmosphere, wanderlust aesthetic' },
      { id: 6, title: '创意手工：变废为宝', category: '创意', description: '旧物改造创意DIY教程。', imageSeq: 'cat-short-06', imageQuery: 'DIY craft short video thumbnail with creative handmade project, bright clean workspace, artistic aesthetic, maker culture visual style' },
    ],
  },
};

export const faqData = [
  {
    question: '如何下载91在线视频APP？',
    answer: '您可以通过访问91在线视频官方网站，在首页找到APP下载区域，选择对应平台（iOS或Android）进行下载。iOS用户也可直接在App Store搜索"91在线视频"进行下载。',
  },
  {
    question: '91在线视频是否免费？',
    answer: '91在线视频提供大量免费内容供用户观看。同时我们也提供VIP会员服务，会员可享受无广告观看、超清画质、离线缓存等专属权益。',
  },
  {
    question: '忘记账号密码怎么办？',
    answer: '在登录页面点击"忘记密码"，按照提示通过绑定的手机号或邮箱进行密码重置。如仍无法解决，请联系官方客服获取帮助。',
  },
  {
    question: '支持哪些设备观看？',
    answer: '91在线视频支持PC网页端、iOS手机/平板、Android手机/平板等主流设备。一个账号可在多个设备上登录使用。',
  },
  {
    question: '如何联系客服？',
    answer: '您可以通过以下方式联系我们：发送邮件至 support@91zaixianshipin.com，或在工作时间拨打客服热线 400-888-9999。VIP会员享有专属客服快速响应通道。',
  },
  {
    question: '视频播放卡顿怎么办？',
    answer: '建议您检查网络连接状况，尝试切换至较低画质（如从1080P切换至720P），或关闭其他占用带宽的应用。如问题持续，可尝试重启APP或清除缓存。',
  },
];